export const social_handles = [
    {
        "enabled": true,
        "image": {
            "public_id": "1708718250873-3038n7.webp",
            "url": "https://portfolio-image-store.s3.ap-south-1.amazonaws.com/1708718250873-3038n7.webp"
        },
        "platform": "GitHub",
        "url": "#",
        "_id": "65b3ea4feb20546ae6d4641d"
    },
    {
        "enabled": true,
        "image": {
            "public_id": "1708718263294-2lfj67.webp",
            "url": "https://portfolio-image-store.s3.ap-south-1.amazonaws.com/1708718263294-2lfj67.webp"
        },
        "platform": "LinkedIn",
        "url": "#",
        "_id": "65b3e99beb20546ae6d463c2"
    },
    {
        "enabled": true,
        "image": {
            "public_id": "1708718346601-xldm.webp",
            "url": "https://portfolio-image-store.s3.ap-south-1.amazonaws.com/1708718346601-xldm.webp"
        },
        "platform": "Facebook",
        "url": "#",
        "_id": "65b3e43cb48589dfcae1856c"
    },
    {
        "enabled": true,
        "image": {
            "public_id": "1708718328750-d4jsq.webp",
            "url": "https://portfolio-image-store.s3.ap-south-1.amazonaws.com/1708718328750-d4jsq.webp"
        },
        "platform": "Twitter",
        "url": "#",
        "_id": "65b3e47cb48589dfcae185bd"
    },
]
